<template>
  <div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert"
    >
      {{ $t('errorMessages.' + error) }}
    </div>
    <template
      v-if="showLogin"
    >
      <div
        id="withMBL">
        <label class="mb-0 mt-3">
          {{ $t("label.email_or_mobile") }}
        </label>
        <div class="form-group mt-2">
          <input
            id="input-email-address"
            v-model.trim="$v.userID.$model"
            class="form-control input-lg"
            data-test="email-address"
            name="userID"
            placeholder="Email"
            type="text"
            @blur="$v.userID.$touch()"
            @input="validateEmail()"
          >
          <small
            v-if="$v.userID.$error && !$v.userID.email"
            id="emailAddressEmptyMsg"
            class="form-text text-danger"
          >
            {{ $t("errorMessages.invalidEmailAddress") }}
          </small>
        </div>
        <div class="form-group row">
          <div class="country-code col-4 col-lg-3 col-md-4 col-sm-4 pr-1">
            <select
              id="consumerCountryCode"
              v-model="countryCode"
              class="form-control form-control pr-1"
              name="countryCode"
              style="padding-left: 8px"
            >
              <option
                v-for="(codes, index) in countryCodes"
                :key="index"
                :value="codes.code + ' ' + codes.dial_code"
              >
                {{ codes.code.concat(" ", codes.dial_code) }}
              </option>
            </select>
          </div>
          <div
            class="phone-number col-8 col-lg-9 col-md-8 col-sm-8"
            style="padding-left: 1px">
            <input
              id="input-phone-number"
              v-model.trim="$v.phoneNumber.$model"
              class="form-control form-control"
              data-test="phone-number"
              name="phoneNumber"
              placeholder="Mobile Number"
              type="number"
              @blur="$v.phoneNumber.$touch()"
              @input="validatePhoneNumber()"
            >
            <small
              v-if="$v.phoneNumber.$error && !$v.phoneNumber.phoneNumberFormat"
              id="invalidPhoneNumberMsg"
              class="form-text text-danger"
            >
              {{ $t("errorMessages.invalidPhoneNumber") }}
            </small>
            <small
              v-if="$v.phoneNumber.$error && !$v.phoneNumber.minLength"
              id="invalidPhoneNumberMsg"
              class="form-text text-danger"
            >
              {{ $t("errorMessages.invalidMinLength").replace('%d', seletedCountry.minimumLength) }}
            </small>
            <small
              v-if="$v.phoneNumber.$error && !$v.phoneNumber.maxLength"
              id="invalidPhoneNumberMsg"
              class="form-text text-danger"
            >
              {{ $t("errorMessages.invalidMaxLength").replace('%d', seletedCountry.maximumLength) }}
            </small>
          </div>
        </div>
      </div>

      <div class="text-center set-margin mt6">
        <small>
          {{ $t ('cardEnrollment.footerText') }}
        </small>
        <div>
          <button
            id="continue-btn"
            :class="{ disabled: !validateEmailOrPhone() }"
            :disabled="!validateEmailOrPhone()"
            class="btn btn-dark btn-lg mt-2 lightbox-btn"
            data-test="btn-continue"
            type="submit"
            @click="submit()"
          >
            {{ $t ('label.continue') }}
          </button>
        </div>
        <div
          id="register-link"
          class="mt-3 cursor-pointer font-weight-bold font15"
          @click="registerPage()"
        >
          {{ $t ('cardEnrollment.checkoutAsUser') }}
        </div>
        <cancel
          v-if="showCancel"
          class="mt-3"
        />
      </div>
    </template>
    <template>
      <div
        :hidden="showLogin"
        class="consumer-auth-module">
        <iframe
          id="authenticationEmbeddedIframe"
          ref="authenticationEmbeddedIframe"
          class="auth-embedded-iframe"
          name="auth-embedded-iframe" />
      </div>
    </template>
  </div>
</template>
<script>
import Cancel from '../../cancel/cancel.vue'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { EventBus } from '@/event-bus'
import { CONSTANT, CHECKOUT_METHODS, windowRefTypes, SDK_ID_MASTERCARD } from '@/utils/constant'
import orchestration from '@/orchestration'
import sharedService from '@/utils/shared-service'
import { mapGetters } from 'vuex'
import checkout from '@/utils/checkout'
import {
  email,
  required,
  helpers,
  maxLength,
  minLength
} from 'vuelidate/lib/validators'
import countryCodes from '../../.././../data/countryCodes.json'
import toasterService from '@/utils/toaster'

// eslint-disable-next-line
const phoneNumberFormat = helpers.regex('phoneNumberFormat', /^\d+$/)
const mobileRegex = /([0-9]{4})+$/

Vue.use(Vuelidate)

export default {

  name: 'Login',

  components: {
    Cancel
  },

  data () {
    return {
      userID: '',
      mblUserID: '',
      error: '',
      validationChannelId: '',
      showCancel: '',
      validInput: false,
      // emailEntered: false,
      isIdentityTypeMobile: false,
      validEmail: false,
      validPhoneNumber: false,
      countryCode: 'US +1',
      countryCodes: countryCodes,
      phoneNumber: '',
      showLogin: true
    }
  },

  computed: {
    ...mapGetters(['supportMobileLookup', 'checkoutMethod', 'enableMPT', 'isConsumerAuthModuleEnable', 'pflExecutionFlow', 'windowRefType', 'isConsumerPresent']),
    seletedCountry: function () {
      let selectedCode = this.countryCode.split(' ')[0]
      return this.countryCodes.find((item) => item.code === selectedCode)
    }
  },

  validations () {
    return {
      userID: {
        required,
        email
      },

      phoneNumber: {
        phoneNumberFormat,
        maxLength: maxLength(this.seletedCountry.maximumLength),
        minLength: minLength(this.seletedCountry.minimumLength)
      }
    }
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.error = event
      setTimeout(() => {
        this.error = ''
      }, 3000)
      this.$store.commit('lightBoxloaderOn', false)
    })
    EventBus.$on('recallInitiateIdentity', (event) => {
      this.userID = event
      this.initiateIdValidation().then(() => {
        this.$store.commit('storeSuccessMsg', 'OTP_RESEND_SUCCESS')
        EventBus.$emit('handleSuccess', 'OTP_RESEND_SUCCESS')
      })
    })
    this.prefillEmail()
  },

  created () {
    this.showCancel = window.opener
  },

  methods: {

    /**
     * This method will prefill email field if user is logged in
     */
    prefillEmail () {
      if (
        this.$store.state.configuration.consumerInfo &&
        this.$store.state.configuration.consumerJwt
      ) {
        this.$v.userID.$model =
          this.$store.state.configuration.consumerInfo.email
        this.validateEmail()
        this.validatePhoneNumber()
      }
    },

    /**
     * This method will check if the email is valid or not
     */
    validateEmail () {
      if (this.$v.userID.$error) {
        this.validEmail = false
      } else {
        this.validEmail = true
      }
    },

    /**
     * This method will check if the phone number is valid or not
     */
    validatePhoneNumber () {
      if (this.$v.phoneNumber.$error) {
        this.validPhoneNumber = false
      } else {
        this.validPhoneNumber = true
      }
    },

    /**
     * This method will enable or disable checkout with login button
     * @returns {boolean}
     */
    validateEmailOrPhone () {
      if (this.phoneNumber) {
        if (!this.countryCode) {
          return true
        }
      }
      if (this.validEmail) {
        if (this.userID) {
          return true
        } else {
          return false
        }
      }
      if (this.validPhoneNumber) {
        if (this.phoneNumber) {
          return true
        } else {
          return false
        }
      }
    },

    validateInput () {
      if (this.$v.userID.$error || this.$v.mblUserID.$error) {
        this.validInput = false
      } else {
        this.validInput = true
      }
    },

    registerPage () {
      sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.REGISTER_SCREEN, this.$router)
    },

    getIdentityTypeParams () {
      let params = {}
      this.isIdentityTypeMobile = mobileRegex.test(this.phoneNumber)
      if (this.isIdentityTypeMobile) {
        params['mobileNumber'] = {
          countryCode: this.countryCode.split('+')[1],
          phoneNumber: this.phoneNumber
        }
      } else {
        params['email'] = this.userID
      }
      return params
    },

    /**
     * This method submits the user id given and calls the lookup profile api
     * @returns {Promise<void>}
     */
    async submit () {
      let params = this.getIdentityTypeParams()
      this.$store.commit('isIdentityTypeMobile', this.isIdentityTypeMobile)
      this.$store.commit('lightBoxloaderOn', true)
      this.$store.commit('setConsumerPresent', false)
      orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.ID_LOOKUP, methodParameters: params }
      ).then(identityLookupResponse => {
        if (identityLookupResponse.consumerPresent) {
          this.consumerPresent(identityLookupResponse)
        } else {
          EventBus.$emit('handleError', 'SRC_PROFILE_NOT_FOUND')
          this.$store.commit('lightBoxloaderOn', false)
          if (this.enableMPT) {
            setTimeout(() => {
              this.registerPage()
            }, 2000)
          }
        }
      }).catch(error => {
        EventBus.$emit('handleError', error || 'SRC_PROFILE_NOT_FOUND')
        this.$store.commit('lightBoxloaderOn', false)
      })
    },

    /* eslint complexity: ["error", 11] */
    /**
     * This method will call if consumer present.
     * for PFL authenticate() will call if `isConsumerAuthModuleEnable` is true
     */
    async consumerPresent (identityLookupResponse) {
      let response
      if (this.isConsumerAuthModuleEnable && this.isConsumerPresent) {
        this.$store.commit('setConsumerPresent', false)
        if (this.pflExecutionFlow === 'EMBEDDED') {
          await this.authenticationMethodsLookupCall()
        }
        response = await this.authenticateConsumerCall()
        if (!response) {
          return
        }
        this.$store.commit('lightBoxloaderOn', false)
        switch (response.authenticationStatus) {
          case 'COMPLETE':
            this.showLogin = false
            if (response.authenticationResult === 'AUTHENTICATED') {
              this.showLogin = true
              this.$store.commit('consumerAuthorization', [response.idToken])
              sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.PAYMENT_SCREEN, this.$router)
            } else if (response.authenticationResult === 'NOT_AUTHENTICATED' && this.pflExecutionFlow === 'EMBEDDED') {
              this.showLogin = true
              this.initiateIdentityLookup(identityLookupResponse)
            }
            break
          case 'NOT_SUPPORTED':
            this.showLogin = true
            this.initiateIdentityLookup(identityLookupResponse)
            break
          case 'CANCELLED':
            sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.REGISTER_SCREEN, this.$router)
            break
          default:
            this.showLogin = true
            this.$store.commit('lightBoxloaderOn', false)
            toasterService.onFailure(this.$t('errorMessages.AUTHENTICATE_FAILED'))
        }
      } else {
        this.initiateIdentityLookup(identityLookupResponse)
      }
    },

    /**
     * This method will initiate initiateIdentityLookup
     */

    initiateIdentityLookup (identityLookupResponse) {
      let networkProcessingOTP = this.checkoutMethod !== CHECKOUT_METHODS.aggregator.name ? identityLookupResponse.networkProcessingOTP : ''
      this.$store.commit('identityFoundAt', networkProcessingOTP)
      this.getSupportedValidationChannels(identityLookupResponse)
      this.initiateIdValidation()
    },

    /**
     * This method will call if consumer present for mastercrad & consumer authentication module
     * enable with EMBEDDED flow
     */
    async authenticationMethodsLookupCall () {
      let params = this.getIdentityTypeParams()
      return orchestration.callMethod({
        methodName: CONSTANT.TRACE.METHOD.AUTHENTICATION_METHODS_LOOKUP,
        methodParameters: params,
        enabledSdks: [SDK_ID_MASTERCARD]
      }).then(authlookupresponse => {
        let isFIDO2 = authlookupresponse.authenticationMethods.some(type => type['authenticationMethodType'] === 'FIDO2')
        if (isFIDO2) {
          EventBus.$emit('handleSuccess', 'FIDO2_FOUND')
        } else {
          EventBus.$emit('handleSuccess', 'FIDO2_NOT_FOUND')
        }
      }).catch(error => {
        EventBus.$emit('handleError', error || 'AUTHENTICATION_METHODS_LOOKUP_FAILED')
        this.$store.commit('lightBoxloaderOn', false)
      })
    },

    /**
     * This method will call if consumer present for mastercrad & consumer authentication module enable
     */
    async authenticateConsumerCall () {
      let params = this.getIdentityTypeParams()

      if (this.windowRefType === windowRefTypes.IFRAME || this.windowRefType === windowRefTypes.ACTION_SHEET) {
        window.consumerAuthWindow = this.$refs.authenticationEmbeddedIframe.contentWindow
      }

      let authenticationMethod = {
        authenticationSubject: 'CONSUMER'
      }
      if (this.pflExecutionFlow === 'EMBEDDED') {
        authenticationMethod['authenticationMethodType'] = 'FIDO2'
      } else {
        this.showLogin = false
        this.$store.commit('lightBoxloaderOn', false)
        authenticationMethod['authenticationMethodType'] = 'MANAGED_AUTHENTICATION'
      }
      if (this.pflExecutionFlow === 'HOSTED' && this.windowRefType === windowRefTypes.POPUP) {
        let windowRef = !window.opener ? checkout : window.opener.checkout
        windowRef.initiateAuthUI({ params, authenticationMethod })
        return false
      } else {
        return orchestration.callMethod({
          methodName: CONSTANT.TRACE.METHOD.AUTHENTICATE_CONSUMER,
          methodParameters: {
            params,
            authenticationMethod
          },
          enabledSdks: [SDK_ID_MASTERCARD]
        }).catch(error => {
          console.log(error)
          sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.REGISTER_SCREEN, this.$router)
          EventBus.$emit('handleError', error || 'CONSUMER_AUTHENTICATE_FAILED')
          this.$store.commit('lightBoxloaderOn', false)
        })
      }
    },

    getSupportedValidationChannels (identityLookupResponse) {
      let supportedValidationChannels = identityLookupResponse.supportedValidationChannels || []
      if (supportedValidationChannels.length > 0) {
        this.validationChannelId = supportedValidationChannels[0].validationChannelId
      }
    },

    async initiateIdValidation () {
      let methodParameters = this.validationChannelId || this.userID
      orchestration.callMethod({
        methodName: CONSTANT.TRACE.METHOD.INITIATE_ID_VALIDATION,
        methodParameters,
        enabledSdks: this.checkoutMethod !== CHECKOUT_METHODS.aggregator.name ? [this.$store.getters.identityFoundAt] : undefined
      }).then(initiateIdResponse => {
        if (initiateIdResponse.maskedValidationChannel) {
          this.$store.commit('validationData', initiateIdResponse)
          let network = this.checkoutMethod === CHECKOUT_METHODS.aggregator.name ? initiateIdResponse.network : this.$store.getters.identityFoundAt
          this.$store.commit('identityFoundAt', network)
          sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.OTP_SCREEN, this.$router)
        } else {
          this.$store.commit('validationData', {})
          EventBus.$emit('handleError', initiateIdResponse.reason || initiateIdResponse.error.reason)
        }
      }).catch(error => {
        this.$store.commit('validationData', {})
        EventBus.$emit('handleError', error || 'OTP_SEND_FAILED')
      }).finally(() => {
        this.$store.commit('lightBoxloaderOn', false)
      })
    }
  }
}
</script>
<style scoped>
  @import "css/card-enrollment.scss";
</style>
